<template>
  <div style="display: flex; flex-direction: column">
    <a-dropdown @onOpenChange="toggleDropdown" v-if="isAuthenticated" placement="top">
      <template #overlay>
        <a-menu @click="handleMenuClick" v-model:selectedKeys="selectedKeys">
          <a-sub-menu key="sub1" title="Andere Funktionen">
            <a-menu-item v-for="route in routes" :key="route.path">
              <DynamicIcon :type="route.icon" />

              <router-link class="nav-text nav-item-mrg" :to="route.path"> {{ t(route.name) }}</router-link>
            </a-menu-item>
          </a-sub-menu>

          <router-link v-if="isAuthenticated === true" class="nav-text" :to="`/settings`">
            <a-menu-item :key="'settings'"> <SettingOutlined /> Einstellungen </a-menu-item>
          </router-link>
          <router-link v-if="isAuthenticated === true" class="nav-text" :to="`/documentation`">
            <a-menu-item :key="'documentation'"> <FileTextOutlined /> Dokumentation </a-menu-item>
          </router-link>

          <a-menu-item v-if="isAuthenticated === true" :key="'logout'"> <logout-outlined /> {{ t("login.action.logout") }} </a-menu-item>
        </a-menu>
      </template>
      <div v-if="isAuthenticated == true" style="width: 100%; display: flex; justify-content: center">
        <a-avatar v-if="props.collapsed">
          <template #icon><UserOutlined /></template>
        </a-avatar>
        <a-button v-else style="width: 100%">
          <span class="username">{{ profile.username }}</span>

          <DownOutlined />
        </a-button>
      </div>
    </a-dropdown>
    <div style="width: 100%" v-else>
      <a-avatar v-if="props.collapsed">
        <template #icon><UserOutlined /></template>
      </a-avatar>
    </div>

    <!-- <span class="username" v-if="isAuthenticated === true">{{ username }}</span>
      <logout-modal v-if="isAuthenticated === true" />

      <login-modal v-else /> -->
  </div>
</template>
<script lang="ts">
import { ref, defineComponent, watch, computed } from "vue";
import { useRoute } from "vue-router";
import router, { getNavigationRoutes } from "../router/index";
import LoginModal from "./LoginModal.vue";
import LogoutModal from "./LogoutModal.vue";
import { DynamicIcon } from "./icons/DynamicIcon";
import { useI18n } from "vue-i18n";
import { CustomIconName, iconName } from "../utils/constants/icons";
import { FEATURE } from "../utils/constants/permission";
import { UserOutlined, DownOutlined, SettingOutlined, LogoutOutlined, FileTextOutlined } from "@ant-design/icons-vue";
import type { MenuProps } from "ant-design-vue";
import { useUserStore } from "../store/modules/user";
import { storeToRefs } from "pinia";
export default defineComponent({
  components: { LoginModal, LogoutOutlined, FileTextOutlined, SettingOutlined, LogoutModal, UserOutlined, DownOutlined, DynamicIcon },
  name: "Navigation",
  emits: ["dropdownToggle"],
  props: {
    collapsed: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup: (props, { emit }) => {
    const store = useUserStore();
    const count = ref(0);
    const activeLink = ref("");
    const { t } = useI18n();

    const handleMenuClick: MenuProps["onClick"] = (e) => {
      if (e.key == "logout") {
        store.authLogout().then(() => {
          router.push("/");
        });
      }
    };
    // const routes = ref<
    //   {
    //     name: string;
    //     path: string;
    //     icon: iconName | CustomIconName;
    //   }[]
    // >([]);

    const route = useRoute();
    const routes = computed(() => {
      const role = store.getProfile.role != null ? store.getProfile.role : "";
      let featuresAllowed: FEATURE[] = [];
      if (store.getTenantConfig.enabledFeatures != null) {
        featuresAllowed = store.tenantFeatures.split(",") as FEATURE[];
      }
      const all = getNavigationRoutes(role, featuresAllowed, store.getIsOAuthToken);

      return all.map((item) => {
        return {
          name: item.name as string,
          path: item.path as string,
          icon: item.meta.icon as iconName | CustomIconName,
        };
      });
    });
    const selectedKeys = ref<string[]>([]);
    watch(
      () => selectedKeys.value,
      () => {
        emit("dropdownToggle");
      },
      { deep: true }
    );
    const { profile, isAuthenticated } = storeToRefs(store);

    watch(
      () => router.currentRoute.value.path,
      (newPath, oldPath) => {
        if (newPath.split("/")[1] === oldPath?.split("/")[1]) {
          return; // Ignore changes if only params changed
        }
        selectedKeys.value = ["/" + newPath.split("/")[1]];
      }
    );

    watch(
      () => profile.value,
      () => {
        activeLink.value = route.path;
      }
    );
    const toggleDropdown = (visible: boolean) => {
      emit("dropdownToggle", visible);
    };
    return {
      count,
      toggleDropdown,
      routes,
      selectedKeys,
      activeLink,
      isAuthenticated,
      router,
      profile,
      props,
      t,
      handleMenuClick,
    };
  },
});
</script>

<style>
header .ant-btn {
  margin-right: 8px;
  margin-bottom: 12px;
}

.username {
  margin-right: 8px;
  margin-bottom: 12px;
}

.ant-menu-horizontal > .ant-menu-item > a {
  display: inline-block !important;
}

.ant-menu-item .anticon,
.ant-menu-submenu-title .anticon {
  display: inline-block;
}

.nav-item-mrg {
  margin-left: 4px;
}
</style>
